module.exports = __webpack_public_path__ + "img/20190730164531888.08918fd5.png";